import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../user.interface';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PasswordValidation } from '@app/users/password-validation';
import { UsersDataService } from '@app/users/users-data.service';
import { NotificationService } from '@app/shared/services/notification.service';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent implements OnInit {

  title: string = "Создание пользователя";
  userForm: FormGroup;
  create = true;
  types = ['admin', 'operator'];

  constructor(private formBuilder: FormBuilder,
    public userService: UsersDataService,
    public dialogRef: MatDialogRef<UserFormComponent>,
    private notification: NotificationService,
    @Inject(MAT_DIALOG_DATA) public user: User) { }

  ngOnInit() {
    this.userService.loadUserFormdData();
    this.createForm();    
  }

  createForm() {
    this.userForm = this.formBuilder.group(
      {
        name: [this.user ? this.user.name : '', Validators.required],
        type: [this.user ? this.user.type : '', Validators.required],
        roles: [this.user ? this.user.roles : []],
        services: [this.user ? this.user.services : []],
        password: ['', this.user ? Validators.nullValidator : Validators.required],
        confirmPassword: ['', this.user ? Validators.nullValidator : Validators.required]
      }, {
        validator: PasswordValidation.MatchPassword
      }
    );
  }

  processResult = (res: any) => {
    if (!res.error) {
      this.dialogRef.close();
    }
  }

  onSubmit() {
    if (this.user) {
      const roles = {
        add: this.userForm.value.roles.filter(el => !this.user.roles.includes(el)) || [],
        remove: this.user.roles.filter(el => !this.userForm.value.roles.includes(el)) || []
      };
      const services = {
        add: this.userForm.value.services.filter(el => !this.user.services.includes(el)) || [],
        remove: this.user.services.filter(el => !this.userForm.value.services.includes(el)) || []
      }
      
      this.userService.emmitEditUser(this.userForm.value, this.user.id);
      this.userService.editUser(this.userForm.value, roles, services, this.user.id).subscribe(this.processResult);
        
    }
    else {
      this.userService.createUser(this.userForm.value).subscribe(res=>{
        this.userService.emmitCreateUser(this.userForm.value, res[0]['data'].id);
      });
      this.userService.getAllUsers().subscribe(this.processResult)
      
    }

  }

}


// WEBPACK FOOTER //
// ./src/app/users/user-form/user-form.component.ts